import { Injectable } from '@angular/core';
import { RequestData } from 'src/app/common/models/request-data.model';
import { SaleItemModel } from './model/sale-item.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class SaleItemService {

  constructor(private http: HttpClient) { }


  getList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/sale-item/get', requestData);

  }
  getSaleItemById(id: number): Observable<any> {
    return this.http.post(environment.baseUrl + '/sale-item/get/' + id, '');

  }
  getStocksList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/stocks/get', requestData);

  }
  getkitchenList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/shop/kitchen/get', requestData);
  }
  getItemClassesList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/itemcategory/get', requestData);

  }
  getTaxList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/common/taxes/get', requestData);

  }
  getUomList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/uom/get', requestData);

  }
  getCustomizationList(requestData: RequestData): Observable<any> {
    // return this.http.post(environment.baseUrl + '/sale-item/get-all-customizations', requestData);
    return this.http.post(environment.baseUrl+'/customization/get-all-customizations', requestData);
  }

  getcustomizationBySaleItem(id: number) {
    return this.http.post(environment.baseUrl + '/sale-item/get-customization-by-sale-item-id/' + id, '');
  }

  getComboList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/sale-item/get-all-combo', requestData);

  }
  update(saleItemInfo: SaleItemModel): Observable<any> {
    if (saleItemInfo.hasOwnProperty("id")) {
      return this.http.post(environment.baseUrl + '/sale-item/update', saleItemInfo);
    } else {
      console.log(saleItemInfo)
      return this.http.post(environment.baseUrl + '/sale-item/add', saleItemInfo);
    }
  }
  downloadExcel(requestData: any): Observable<Blob> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    // const url = 'http://yourdomain.com/api/customers/export'; // Adjust URL

    return this.http.post(environment.baseUrl + '/sale-item/export-items', requestData, { headers, responseType: 'blob' })
      .pipe(
      //catchError(this.handleError)
    );

  }

  /**
   * 
   * @param saleItemInfoInfo 
   * Calls the API to delete the record
   */
  delete(saleItemInfo: SaleItemModel): Observable<any> {
    return this.http.post(environment.baseUrl + '/sale-item/delete/' + saleItemInfo.id, saleItemInfo);
  }
   getGroupItemList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/sale-item/get-group-items', requestData);

  }
  getItemClassByGroupId(groupItemId: number): Observable<any> {
    return this.http.get(environment.baseUrl + '/sale-item/item-class-by-group/' + groupItemId);
  }

  getAllItemClasses(): Observable<any> {
    return this.http.get(environment.baseUrl + '/sale-item/get-all-item-classes');
  }

  /**
   * Update group item order and short names
   * @param groupItemArray Array of group item data
   * @returns Observable<any>
   */
  updateGroupItemOrder(groupItemArray: any[]): Observable<any> {
    const url = environment.baseUrl +'/sale-item/update-group-order';
    return this.http.put<any>(url, { groupItems: groupItemArray });
  }

  /**
   * Update group item data (code, name, colors, hot items, etc.)
   * @param groupItemData Group item data to update
   * @returns Observable<any>
   */
  updateGroupItemData(groupItemData: any): Observable<any> {
    const url = environment.baseUrl+ '/sale-item/update-group-item';
    return this.http.put<any>(url, groupItemData);
  }
   /**
   * Update group item data (code, name, colors, hot items, etc.)
   * @param groupItemData Group item data to add
   * @returns Observable<any>
   */
  addGroupItemData(groupItemData: any): Observable<any> {
    const url = environment.baseUrl+ '/sale-item/add-group-item';
    return this.http.post<any>(url, groupItemData);
  }

  resetShopPrice(data: any): Observable<any> {
    return this.http.post<any>(environment.baseUrl + '/sale-item/reset-shop-price', data); 
  }
}
